import React from 'react';

interface SvgIconProps {
  src: string;
  className?: string;
  color?: string;
  size?: number;
  onClick?: () => void;
}

const SvgIcon: React.FC<SvgIconProps> = ({ 
  src, 
  className = "", 
  color, 
  size = 24,
  onClick 
}) => {
  const [svgContent, setSvgContent] = React.useState<string>('');

  React.useEffect(() => {
    fetch(src)
      .then(response => response.text())
      .then(svgText => {
        if (color) {
          // Заменяем fill и stroke атрибуты на нужный цвет
          let coloredSvg = svgText.replace(/fill="[^"]*"/g, `fill="${color}"`);
          coloredSvg = coloredSvg.replace(/stroke="[^"]*"/g, `stroke="${color}"`);
          setSvgContent(coloredSvg);
        } else {
          setSvgContent(svgText);
        }
      })
      .catch(error => console.error('Ошибка загрузки SVG:', error));
  }, [src, color]);

  return (
    <div
      className={`flex items-center justify-center ${className}`}
      style={{ width: size, height: size }}
      onClick={onClick}
      dangerouslySetInnerHTML={{ __html: svgContent }}
    />
  );
};

export default SvgIcon; 
